export default class SlickSlider {
  constructor (obj = {}) {

    this.options = {
      initClass: 'js--init',
    };
    this.$el = $('[data-slider]:not(.' + this.options.initClass + ')');
    this.$body = $('body');


    return this;
  }


  init () {
    let _this = this;


    let interval = setInterval(function () {
      if (typeof $.fn.slick === 'function') {


        _this.$el.addClass(_this.options.initClass).each(function () {
          let $this = $(this);
          let data = $this.data('slider');

          data.prevArrow = "<button type=\"button\" class=\"slick-prev\"><span class=\"icon icon-chevron-left\"></span></button>";
          data.nextArrow = "<button type=\"button\" class=\"slick-next\"><span class=\"icon icon-chevron-right\"></span></button>";

          $this.slick(data);
        });


        clearInterval(interval);
      }
    }, 50);


  }


  render () {
    if (this.$el.length) {
      this.init();
    }
    return this;
  }
}
